const confirmAuth = (moduleName) => {
  let moduleAuth = {
    read: true,
    create: true,
    uploadFile: true,
    importData: true,
    delete: true,
    update: true,
    search: true,
  }
  // 获取权限列表，根据传递当前的moduleName 来查询 当前菜单。再根据当前菜单的Id 来查询当前的页面的权限
  const storageUser = localStorage.getItem('CurrentUser')
  if (!moduleName || !storageUser) {
    return moduleAuth
  }
  const userInfo = JSON.parse(storageUser)
  const roleLimits = userInfo._RoleLimits
  const currentMenuRoleLimits = _.filter(roleLimits, (item) => {
    return item.FkName === moduleName
  })
  const permission =
    typeof currentMenuRoleLimits[0].Permission === 'string'
      ? JSON.parse(currentMenuRoleLimits[0].Permission)
      : currentMenuRoleLimits[0].Permission
  moduleAuth = {
    read: true,
    update: permission.includes('Edit'),
    create: permission.includes('Add'),
    delete: permission.includes('Del'),
    importData: permission.includes('Import'),
    uploadFile: permission.includes('Export'),
    search: !permission.includes('NoSearch'),
    addTo: permission.includes('添加到'),
  }
  return moduleAuth
}

export default confirmAuth
